import SplitContent from './SplitContent'
import SplitContentContainer from './SplitContentContainer'

export {
  SplitContentContainer
}

export default SplitContent
